import { useQuery } from "@tanstack/react-query";
import { callApi } from "../callEndpoint";
import {
  specialtyEndpoints,
  type Specialty,
} from "../contracts/specialties.contract";

export const useSpecialties = () =>
  useQuery({
    queryKey: ["specialties"],
    queryFn: () => callApi<Specialty[]>(specialtyEndpoints.list),
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    staleTime: Infinity,
  });
